import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetMyPreferences = ({ enabled = true } = {}) => {
  const query = useApiQuery(
    ['courseAssignmentPreferences'],
    'schools',
    '/current-enrollment/course-assignment/preferences',
    { enabled },
    { authenticated: true, version: 5 }
  )

  return {
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    classmateEnrollmentIds: query.data?.classmateEnrollmentIds ?? [],
    submittedAt: query.data?.submittedAt ?? null,
    error: query.error,
    refetch: query.refetch
  }
}
